import Layout from "@/components/Layout";
import { Container } from "@chakra-ui/react";
import Header from "components/Header";

import SplitFeature from "components/SplitFeature";
import { contentTag, featuredImage } from "utils/constants";
import { fetchPageContent } from "utils/fetchApi";

const GettingStarted = ({ providersContent, individualsContent }) => {
  return (
    <Layout>
      <Header browserTitle="WellFitly - Getting Started" />
      <Container maxW={"7xl"} minH={"100vh"} p="6">
        <SplitFeature
          btnId="btn-providers-signup"
          tag={providersContent.sub_title}
          headerTitle={providersContent.main_title}
          content={providersContent.content}
          featureImage={providersContent.featureImage}
          paddingBottom={20}
        />
        <SplitFeature
          btnId="btn-individuals-signup"
          tag={individualsContent.sub_title}
          headerTitle={individualsContent.main_title}
          content={individualsContent.content}
          featureImage={individualsContent.featureImage}
          paddingBottom={20}
        />
      </Container>
    </Layout>
  );
};

export default GettingStarted;

export const getStaticProps = async () => {
  const providersContent = await fetchPageContent({
    tag: contentTag.forProvidersPage,
  });

  const individualsContent = await fetchPageContent({
    tag: contentTag.forIndividualsPage,
  });

  return {
    props: {
      providersContent: {
        ...providersContent,
        featureImage: featuredImage[contentTag.forProvidersPage],
      },
      individualsContent: {
        ...individualsContent,
        featureImage: featuredImage[contentTag.forIndividualsPage],
      },
    },
  };
};
